// custom validation for inputs that don't belong to a custom form component (e.g. the signup form)
export default (e) => {
    if (!e || !e.target) return;
    if (e.target) {
        const currentInput = e.target;
        const container = currentInput.parentElement;
        container.classList.add('hide-error-msg');
    }
};
